<template>
  <header>
    <div class="page-header min-vh-80 bg-gradient-dark">
      <video
        class="position-absolute fixed-top  h-100 z-index-0  rounded-5 px-0"
        id="video"
        playsinline="playsinline"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
        poster="@/assets/img/cloud.jpg"
        style="object-fit: cover;"
      ><source
        type="video/mp4"
        src="assets/img/cloudraise.mp4"
      ></video> 
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-12 my-auto fadeIn1 fadeInBottom">
            <div class="brand text-center text-lg-start">
              <h2 class="text-white mb-3 mb-md-4">
                用科技引領生活的改變
              </h2>
              <h5 class="text-white text-normal">
	       智慧城市、智慧園區、智慧工廠、AI人工智能<br>
	       數位雙生、元宇宙智能教育、教育科技
              </h5>
              <h6 class="text-white text-normal">
                Cloud Raise Technology 提供你更多更好的解決方案
              </h6>
              <button
                class="btn btn-white mt-4 d-none d-lg-block"
                type="button"
                name="button"
                @click="goToPage('Products')"
              >
                了解更多
              </button>
            </div>
          </div>
          <div class="col-lg-7 ms-lg-auto fadeIn2 fadeInBottom">
            <img
              src="assets/img/macbook-2.png"
              class="w-100 z-index-2 ms-lg-5 mt-lg-6"
              loading="lazy"
            >
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
/* eslint-disable import/no-unresolved */
// eslint-disable-next-line no-unused-vars
import { useI18n } from 'vue-i18n';
import { h, ref, reactive , watch , inject , onMounted , onUpdated} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { config , dev , oltConsole, oAA , oApiError , oAdminFrame, oAuth, oUserInfo} from '@/lib/oltModule/initAdminVue3';
import moment from 'moment' ;
//import { DotnetNav , PHPNav } from '@/components/Frame/NavMenu';
//import Loading from 'vue-loading-overlay';
//import 'vue-loading-overlay/dist/vue-loading.css';
import { useStore } from 'vuex';

export default {
  props: {
    /* eslint-disable vue/require-default-prop */
    showmode: String,
    tname: String,
    hiddenHeader:Boolean,
    routerBack:Boolean,
    routerName:String,
    routerTitle:String,
    rightbtnname: String,
    onright:Function,
    onleft:Function,
    rightbtnstatus: String,
    righttype: String
  },
  setup () {
    const { t, locale } = useI18n({
      useScope:'global' // 必需設定 SCOPE 才能覆蓋設定
    }); 

    locale.value = 'zh-TW';

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    function goToPage(page){
      router.push( { path: page } );
    }

    return {
      dev,
      config,
      // moment 
      moment,
      // i18n
      t,
      locale,      
      // record page
      fullPage: true,     
      // const data
      token:null,
      goToPage,
    };
  },
};
</script>

